import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class AvailabilityPill extends Component {
  static propTypes = {
    event: PropTypes.shape({
      isPast: PropTypes.bool.isRequired,
      isHosting: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      isAttending: PropTypes.bool.isRequired,
      isPastSignup: PropTypes.bool.isRequired,
      isBookable: PropTypes.bool.isRequired,
      isBooked: PropTypes.bool.isRequired,
      isScarce: PropTypes.bool.isRequired,
      availableSlots: PropTypes.number,
    }).isRequired,
    className: PropTypes.string,
  };

  render() {
    let classes = ['u-pill', this.props.className];
    let text = null;

    if (this.props.event.isPast) {
      classes.push('u-pill--grey');
      text = 'Past event';
    }

    if (this.props.event.isHosting) {
      text = this.props.event.isPast ? 'You hosted' : "You're hosting";
    } else if (this.props.event.isPending) {
      classes.push('u-pill--blue');
      text = 'RSVP pending';
    } else if (this.props.event.isAttending) {
      text = this.props.event.isPast ? 'You attended' : "You're going";
    } else if (
      (this.props.event.isPastSignup || this.props.event.isBooked) &&
      !this.props.event.isPast
    ) {
      classes.push('u-pill--grey');
      text = 'RSVPs unavailable';
    } else if (this.props.event.isBookable) {
      if (this.props.event.isScarce) {
        classes.push('u-pill--orange');
        text = `${this.props.event.availableSlots} space${
          this.props.event.availableSlots > 1 ? 's' : ''
        } left`;
      } else if (!this.props.event.isPast) {
        classes.push('u-pill--green');
        text = 'Available';
      }
    }

    return text ? <span className={classes.join(' ')}>{text}</span> : null;
  }
}
